import { connect } from "react-redux";
import { ADD_BOOKMARKS } from "redux/bookmarks";
import { LOAD_MORE_RESULTS } from "redux/chat";
import { BOOKMARKABLE_TYPES } from "utils/chatDocumentTypes";
import {
  copyToClipboard,
  formatMessage,
  formatMessageHtml,
} from "utils/chatTranscript";
import { entityType } from "utils/commons";
import trackEvent from "utils/trackEvent";

export const CHAT_BOOKMARKS_CAP = 30;

// Row under bot messages that have documents[]: Give me more (pagination),
// Bookmark all (this message's documents, respecting the 30-item cap
// client-side) and Copy (this message only). "Download All" downloads the
// user's whole persisted bookmark collection, so it lives in the ChatPanel
// header instead of repeating per message - see README for that call.
const ChatResultActions = ({
  message,
  bookmarkedCodes,
  totalBookmarkCount,
  loadMore,
  bookmarkAll,
}) => {
  const documents = message.documents || [];
  if (!documents.length) return null;

  const hasMore = !!message.pagination?.has_more;
  const bookmarkableDocuments = documents.filter(d =>
    BOOKMARKABLE_TYPES.has(d.type)
  );
  const newDocuments = bookmarkableDocuments.filter(
    d => !bookmarkedCodes.includes(d.code)
  );
  const wouldExceedCap =
    totalBookmarkCount + newDocuments.length > CHAT_BOOKMARKS_CAP;

  return (
    <div className="chat-result-actions">
      {hasMore && (
        <button
          type="button"
          className="chat-result-action-btn"
          onClick={() => {
            trackEvent("CHAT_LOAD_MORE_RESULTS", { messageId: message.id });
            loadMore(message.id);
          }}>
          Give me more
        </button>
      )}
      {bookmarkableDocuments.length > 0 && (
        <button
          type="button"
          className="chat-result-action-btn"
          disabled={wouldExceedCap || newDocuments.length === 0}
          title={
            wouldExceedCap
              ? `Bookmarking these would exceed the ${CHAT_BOOKMARKS_CAP}-item bookmark cap.`
              : undefined
          }
          onClick={() => {
            trackEvent("CHAT_BOOKMARK_ALL", { count: newDocuments.length });
            bookmarkAll(newDocuments);
          }}>
          Bookmark all
        </button>
      )}
      <button
        type="button"
        className="chat-result-action-btn"
        title="Copy chat message"
        aria-label="Copy chat message"
        onClick={() => {
          trackEvent("CHAT_COPY_MESSAGE", { messageId: message.id });
          copyToClipboard(formatMessage(message), formatMessageHtml(message));
        }}>
        Copy
      </button>
      {wouldExceedCap && (
        <span className="chat-result-action-warning">
          Bookmark cap ({CHAT_BOOKMARKS_CAP}) reached - remove some bookmarks
          first.
        </span>
      )}
    </div>
  );
};

export default connect(
  ({ bookmarks }) => {
    const offeringTopicsCodes = bookmarks?.offeringTopicsCodes || [];
    const qualificationsCodes = bookmarks?.qualificationsCodes || [];
    return {
      bookmarkedCodes: [...offeringTopicsCodes, ...qualificationsCodes],
      totalBookmarkCount:
        offeringTopicsCodes.length + qualificationsCodes.length,
    };
  },
  dispatch => ({
    loadMore: messageId => dispatch(LOAD_MORE_RESULTS(messageId)),
    bookmarkAll: documents =>
      dispatch(
        ADD_BOOKMARKS({
          qualificationsCodes: documents
            .filter(doc => doc.type === entityType.QUALIFICATION)
            .map(doc => doc.code),
          offeringTopicsCodes: documents
            .filter(doc => doc.type === entityType.OFFERING_TOPIC)
            .map(doc => doc.code),
        })
      ),
  })
)(ChatResultActions);
